<app-expansion-panel 
    [title]="equipmentDetails.id ? 'Equipment' : 'Serial Range'"
    [description]="equipmentDetails.id ? (equipmentDetails.id.endsWith('.0') ? equipmentDetails.id.slice(0, -2) : equipmentDetails.id) : (equipmentDetails.serialNumberRange ? (equipmentDetails.serialNumberRange.includes('#') ? equipmentDetails.serialNumberRange.replace('#', ' - ').replace('.0', '') : 'N/A') : 'Not Found')"
    [isTitleBold]="false"
    [isDefaultOpen]="false"
>
    <div class="equipment-panel-container">
        <div *ngIf="equipmentDetails.make" class="equipment-panel-item">
            <div class="equipment-panel-item-title">Make</div>
            <div class="equipment-panel-item-description">{{equipmentDetails.make}}</div>
            <div class="equipment-panel-item-empty"></div>
        </div>
        <div *ngIf="equipmentDetails.model" class="equipment-panel-item">
            <div class="equipment-panel-item-title">Model</div>
            <div class="equipment-panel-item-description">{{equipmentDetails.model}}</div>
            <div class="equipment-panel-item-empty"></div>
        </div>
        <div *ngIf="equipmentDetails.pvc || equipmentDetails.serialNumberRange" class="equipment-panel-item">
            <div class="equipment-panel-item-title">{{ equipmentDetails.pvc ? 'PVC' : 'Serial No.' }}</div>
            <div class="equipment-panel-item-description">
                {{ equipmentDetails.pvc ? (equipmentDetails.pvc.endsWith('.0') ? equipmentDetails.pvc.slice(0, -2) : equipmentDetails.pvc) : (equipmentDetails.serialNumberRange.endsWith('.0') ? equipmentDetails.serialNumberRange.slice(0, -2) : equipmentDetails.serialNumberRange) }}
            </div>
            <div class="equipment-panel-item-empty"></div>
        </div>
    </div>
</app-expansion-panel>
